<template>
  <div class="animated fadeIn">
    <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
    <b-card v-else>
      <template v-slot:header>
        <h5>Detail Transaksi Gadai</h5>
      </template>
      <DetailGadaiKomp
        :detailGadai="dataDetailTransaksi"
        @onStatusDisbursed="onStatusDisbursed"
        @onSafeRetryReset="onSafeRetryReset"
      />
      <div class="divider" />
      <div v-if="dataDetailTransaksi.statusGadai != 'Void'" class="cetak-sbg-btn">
        <div class="footer-wrapper-detail-transaksi-gadai">
          <div class="footer-wrapper-btn-detail-transaksi-gadai">
            <!-- <b-button variant="pgiBtn" name="cetakBtn" @click="confirmCetakSbg">
              <i class="fa fa-print mr-2"></i> Cetak SBG
            </b-button> -->
            <b-button
              v-for="item in sbgButtons"
              :key="item.tipe"
              variant="pgiBtn"
              name="cetakBtnBaru"
              @click="confirmCetakSbgByTipe(item.tipe)"
            >
              <i class="fa fa-print mr-2"></i>
              {{ item.label }}
            </b-button>
            <div># Print: {{ dataDetailTransaksi.counterPrintSbg }}</div>
          </div>

          <div v-if="showVoidButton">
            <b-button class="mr-3" variant="danger" name="cetakBtn" @click="confirmVoidGadai">
              Void
            </b-button>
          </div>
        </div>
      </div>
    </b-card>
    <ModalConfirm id="modal-confirm-cetak" title="Confirm Cetak SBG" :isSubmitting="isSubmitting" :alertMessage="alertMsg"
      desc="Apakah anda yakin untuk mencetak SBG ini?" @submit="onSubmit" />
    <ModalConfirm id="modal-confirm-cetak-baru" :title="`Confirm Cetak SBG ${capitalize(tipeSbg)}`" :isSubmitting="isSubmitting"
      :alertMessage="alertMsg" :desc="`Apakah anda yakin untuk mencetak SBG ${tipeSbg} ini?`" @submit="onSubmitBaru" />
    <ModalDisbursementRetry
      modal-id="modal-safe-to-retry"
      :retry-count="safeToRetry.retryCount"
      :max-retry="safeToRetry.maxRetry"
      :countdown="safeToRetry.countdown"
      :is-submitting="isSubmitting"
      @retry="onRetryDisbursement"
      @switch-to-cash="onSwitchToCashSafeRetry"
    />
    <b-modal id="modal-confirm-void" centered :no-close-on-backdrop="isSubmitting" :no-close-on-esc="isSubmitting"
      :hide-header-close="isSubmitting" title="Confirm Void Gadai">
      Apakah anda yakin untuk void gadai ini? <br />
      Jika ya, mohon isi kotak keterangan di bawah.
      <b-form id="voidTransaksiGadaiForm" @submit.prevent="onVoid">
        <div class="form-content-wrapper mb-0">
          <b-form-group class="mt-2 mb-0" label="Keterangan">
            <b-form-textarea v-model="keterangan" name="keterangan" rows="3" required></b-form-textarea>
          </b-form-group>
        </div>
      </b-form>
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button variant="secondary" name="cancelSubmitBtn" @click="cancel()" :disabled="isSubmitting">
          Cancel
        </b-button>
        <b-button variant="pgiBtn" type="submit" name="okeSubmitBtn" form="voidTransaksiGadaiForm"
          :disabled="isSubmitting">
          <b-spinner small type="grow" v-if="isSubmitting"></b-spinner>
          {{ isSubmitting ? "Memproses..." : "Ya" }}
        </b-button>
      </template>
    </b-modal>
    <b-modal title="Print SBG/Kwitansi/Barcode" no-close-on-esc no-close-on-backdrop size="xl" id="modal-print"
      :hide-header-close="showDisbursementPendingAlert"
      @hide="goToCashierTransaction">
      <DisbursementPendingAlert v-if="showDisbursementPendingAlert" />
      <p class="smallText text-muted">
        Bila tombol print / cetak tidak ditemukan, anda dapat melakukan
        pencetakan dengan cara klik kanan pada lembar yang akan dicetak, lalu
        pilih Print.
      </p>
      <b-row class="mb-2">
        <b-col class="detail-data-label">Surat Bukti Gadai (SBG)</b-col>
      </b-row>
      <b-row class="mb-2">
        <b-col><iframe width="100%" height="300" :src="urlSBG" frameborder="0" allowfullscreen></iframe></b-col>
      </b-row>
      <b-row class="mb-2">
        <b-col class="detail-data-label">Kwitansi</b-col>
      </b-row>
      <b-row class="mb-2">
        <b-col><iframe width="100%" height="300" :src="urlKwitansi" frameborder="0" allowfullscreen></iframe></b-col>
      </b-row>
      <b-row class="mb-2">
        <b-col class="detail-data-label">Barcode</b-col>
      </b-row>
      <b-row class="mb-2">
        <b-col><iframe width="100%" height="300" :src="urlBarcode" frameborder="0" allowfullscreen></iframe></b-col>
      </b-row>
      <template v-slot:modal-footer="{ ok }">
        <b-button
          v-if="showDisbursementPendingAlert"
          variant="danger"
          @click="goToDisbursementPending"
        >
          Lanjut ke Disbursement Pending
        </b-button>
        <b-button v-else variant="primary" @click="ok()">OK</b-button>
      </template>
    </b-modal>
    <b-modal :title="`Print SBG/Kwitansi/Barcode ${capitalize(tipeSbg)}`" no-close-on-esc no-close-on-backdrop size="xl"
      id="modal-print-baru" :hide-header-close="showDisbursementPendingAlert" @hide="goToCashierTransaction">
      <DisbursementPendingAlert v-if="showDisbursementPendingAlert" />
      <p class="smallText text-muted">
        Bila tombol print / cetak tidak ditemukan, anda dapat melakukan
        pencetakan dengan cara klik kanan pada lembar yang akan dicetak, lalu
        pilih Print.
      </p>
      <b-row class="mb-2">
        <b-col class="detail-data-label">Surat Bukti Gadai (SBG) - {{capitalize(tipeSbg)}}</b-col>
      </b-row>
      <b-row class="mb-2">
        <b-col>
          <div style="height:300px" v-if="tipeSbg == 'v4'">
            <SbgCabangV4 :data-anggota="dataDetailTransaksi" :data="dataSbg" style="overflow:scroll">
            </SbgCabangV4>
          </div>

          <div style="height:300px" v-else-if="tipeSbg == 'v3'">
            <SbgCabangJuni :data-anggota="dataDetailTransaksi" :data="dataSbg" style="overflow:scroll">
            </SbgCabangJuni>
          </div>

          <div style="height:300px" v-else>
            <SbgCabangReport :data-anggota="dataDetailTransaksi" :data="dataSbg" style="overflow:scroll">
            </SbgCabangReport>
          </div>
        </b-col>
      </b-row>
      <b-row class="mb-2">
        <b-col class="detail-data-label">Kwitansi</b-col>
      </b-row>
      <b-row class="mb-2">
        <b-col><iframe width="100%" height="300" :src="urlKwitansi" frameborder="0" allowfullscreen></iframe></b-col>
      </b-row>
      <b-row class="mb-2">
        <b-col class="detail-data-label">Barcode</b-col>
      </b-row>
      <b-row class="mb-2">
        <b-col><iframe width="100%" height="300" :src="urlBarcode" frameborder="0" allowfullscreen></iframe></b-col>
      </b-row>
      <template v-slot:modal-footer="{ ok }">
        <b-button
          v-if="showDisbursementPendingAlert"
          variant="danger"
          @click="goToDisbursementPending"
        >
          Lanjut ke Disbursement Pending
        </b-button>
        <b-button v-else variant="primary" @click="ok()">OK</b-button>
      </template>
    </b-modal>
    <b-modal title="Perhatian !" ok-only no-close-on-esc no-close-on-backdrop size="xl"
      id="modal-perhatian" @hide="goToCashierTransaction">
      <h2>Perhatian!</h2>
      <p>Gadai ini sudah ditransaksikan (status sudah berjalan dan kas sudah terpotong).</p>
      <p>Namun, pencetakan SBG, kwitansi, dan barcode tidak dapat dilakukan karena terdapat kesalahan pada foto identitas nasabah.</p>
      <p>Mohon lakukan edit data nasabah, upload foto identitas nasabah terbaru, dan coba kembali cetak SBG.</p>
    </b-modal>
    <ModalErrorAction
      modal-id="modal-error-cetak-sbg"
      title="Error"
      :message="errorCetakMessage"
      button-label="OK"
      dialog-class="modal-error-cetak-sbg-dialog"
    />
  </div>
</template>
  
<script>
import DetailGadaiKomp from "@/components/gadai/DetailGadaiKomp";
import SbgCabangReport from "./SbgCabangReport";
import SbgCabangJuni from "./SbgCabangJuni";
import SbgCabangV4 from "./SbgCabangV4";
import ModalErrorAction from "@/components/modals/ModalErrorAction";
import ModalDisbursementRetry from "@/components/modals/ModalDisbursementRetry";
import DisbursementPendingAlert from "@/components/disbursement/DisbursementPendingAlert";
import CONSTANTS from '@/constants'

export default {
  name: "detail-transaksi-gadai",
  components: {
    DetailGadaiKomp,
    SbgCabangReport,
    SbgCabangJuni,
    SbgCabangV4,
    ModalErrorAction,
    ModalDisbursementRetry,
    DisbursementPendingAlert,
  },
  data() {
    return {
      id: null,
      initStatus: 0,
      isSubmitting: false,
      alertMsg: "",
      dataDetailTransaksi: [],
      urlSBG: null,
      urlKwitansi: null,
      urlBarcode: null,
      keterangan: "",
      dataSbg: null,
      tipeSbg: '',
      isSuccessGetData: false,
      statusDisbursed: null,
      sbgButtons: [
        { tipe: 'baru', label: 'Cetak SBG Baru' },
        { tipe: 'v3', label: 'Cetak SBG V3' },
        { tipe: 'v4', label: 'Cetak SBG V4' },
      ],
      errorCetakMessage: "",
      showDisbursementPendingAlert: false,
      disbursementPendingNoFaktur: "",
      skipPrintModalRedirect: false,
      safeToRetryTimer: null,
      safeToRetry: {
        retryCount: 1,
        maxRetry: 3,
        countdown: 60,
        submitType: null,
      },
    };
  },
  computed: {
    STATUS_DISBURSEMENT_GADAI(){
      return CONSTANTS.GADAI.STATUS_DISBURSEMENT_GADAI
    },
    NON_TUNAI() {
      return CONSTANTS.GADAI.METODE_PENCAIRAN.NON_TUNAI
    },
    isNonCashDisbursement() {
      return this.dataDetailTransaksi.disburseType == this.NON_TUNAI
    },
    showVoidButton() {
      return ![
        this.STATUS_DISBURSEMENT_GADAI.DISBURSED,
        this.STATUS_DISBURSEMENT_GADAI.DANA_DITANGGUHKAN,
        this.STATUS_DISBURSEMENT_GADAI.DANA_DITANGGUHKAN_GAGAL,
        this.STATUS_DISBURSEMENT_GADAI.CEK_IT,
      ].includes(this.statusDisbursed)
    },
  },
  methods: {
    //----------------- Fungsi Inisialisasi -----------------

    init() {
      this.initStatus = 0;
      this.id = this.$route.params.id;

      let getSingleTransaksi = this.$axios
        .get(`gadai/detail/id/${this.id}`)
        .then((response) => {
          this.dataDetailTransaksi = response.data;
          if (this.shouldAutoSwitchToCash(response.data)) {
            this.onSwitchToCashSafeRetry();
          }
        });

      Promise.all([getSingleTransaksi])
        .then(() => {
          this.initStatus = 1;
        })
        .catch((error) => {
          console.log(error);
          this.initStatus = -1;
        });
    },

    //----------------- Submit Request Cetak SBG -----------------

    async onSubmit() {
      if (this.showStoredSafeToRetryModal('lama')) return;

      this.isSubmitting = true;
      this.removeSafeToRetryState();

      try {
        const response = await this.getCetakSbgResponse();
        this.showCetakSbgLama(response);
      } catch (error) {
        this.handleCetakSbgError(error, 'lama');
      } finally {
        this.isSubmitting = false;
      }
    },

    async onSubmitBaru() {
      if (this.showStoredSafeToRetryModal('baru')) return;

      this.isSubmitting = true;
      this.removeSafeToRetryState();

      try {
        const response = await this.getCetakSbgResponse();
        await this.showCetakSbgBaru(response);
      } catch (error) {
        this.handleCetakSbgError(error, 'baru');
      } finally {
        this.isSubmitting = false;
      }
    },

    async getCetakSbgResponse() {
      const cetakRes = await this.$axios.get("gadai/cetak_sbg/" + this.id);
      const jsonRes = await this.$axios.get("gadai/cetak_sbg_json/" + this.id);

      return { cetakRes, jsonRes };
    },

    showCetakSbgLama({ cetakRes, jsonRes }) {
      this.dataDetailTransaksi.counterPrintSbg++;
      this.$helper.setFlash(`Request Cetak SBG berhasil dilakukan!`);
      this.$bvModal.hide("modal-confirm-cetak");

      let msg = this.$helper.getFlash();
      this.$helper.toastSucc(this, msg);

      this.setDisbursementPendingAlertFromResponse(jsonRes);
      this.gantiUrlPrint(cetakRes);
      this.$bvModal.show("modal-print");
    },

    async showCetakSbgBaru({ cetakRes, jsonRes }) {
      this.dataDetailTransaksi.counterPrintSbg++;
      const msg = this.$helper.getFlash();
      this.$helper.toastSucc(this, msg);
      this.gantiUrlPrint(cetakRes);

      const time = Math.floor(Date.now() / 1000);
      this.setDisbursementPendingAlertFromResponse(jsonRes);
      this.dataSbg = this.getSbgDataFromResponse(jsonRes);
      this.dataSbg.fotoIdentitas += `?v=${time}`;

      this.dataSbg.fotoBase64 = await this.convertImageToBase64(
        this.dataSbg.fotoIdentitas
      );

      this.$helper.toastSucc(this, "Request Cetak SBG berhasil dilakukan!");
      this.$bvModal.hide("modal-confirm-cetak-baru");
      this.$bvModal.show("modal-print-baru");
    },

    handleCetakSbgError(error, submitType) {
      const message = this.$helper.parseError(this, error, '', false);
      const safeToRetryError = this.getSafeToRetryError(message);

      if (safeToRetryError.isSafeToRetry) {
        this.showSafeToRetryModal(submitType, safeToRetryError.retryCount);
        return;
      }

      this.showModalErrorCetak(message);
    },

    getSafeToRetryError(message) {
      const safeToRetryMessage = "Disbursement gagal namun aman untuk dicoba kembali.";
      const maxRetryMessage = "Disbursement telah gagal 3 kali. Pengajuan harus diganti menjadi pencairan tunai.";
      const safeToRetryMatch = String(message).match(new RegExp(`^(\\d+) - ${safeToRetryMessage.replace(/\./g, '\\.')}$`));

      if (safeToRetryMatch) {
        return {
          isSafeToRetry: true,
          retryCount: Number(safeToRetryMatch[1]),
        };
      }

      if (message === maxRetryMessage) {
        return {
          isSafeToRetry: true,
          retryCount: this.safeToRetry.maxRetry,
        };
      }

      return {
        isSafeToRetry: false,
        retryCount: 1,
      };
    },

    showModalErrorCetak(message) {
      this.errorCetakMessage = this.$helper.isNotNullAndNotEmpty(message)
        ? message
        : "Terjadi kesalahan saat proses cetak SBG.";
      this.$bvModal.hide("modal-confirm-cetak");
      this.$bvModal.hide("modal-confirm-cetak-baru");
      this.$bvModal.show("modal-error-cetak-sbg");
    },

    getSbgDataFromResponse(response) {
      return response && response.data ? response.data.data : null;
    },

    setDisbursementPendingAlertFromResponse(response) {
      const data = this.getSbgDataFromResponse(response);
      this.showDisbursementPendingAlert = !!(data && data.isTerimaTPlusOne === true);
      this.disbursementPendingNoFaktur = this.showDisbursementPendingAlert && data && data.noFaktur
        ? data.noFaktur
        : "";
    },

    shouldAutoSwitchToCash(data) {
      return data && data.wajibTunai === true && data.disburseType == this.NON_TUNAI;
    },

    getSafeToRetryStorageKey() {
      return `safeRetry:${this.id}`;
    },

    getStoredSafeToRetryState() {
      try {
        return JSON.parse(localStorage.getItem(this.getSafeToRetryStorageKey()));
      } catch (error) {
        return null;
      }
    },

    saveSafeToRetryState(startedAt) {
      const payload = {
        retryCount: this.safeToRetry.retryCount,
        submitType: this.safeToRetry.submitType,
        startedAt: startedAt || Date.now(),
      };

      localStorage.setItem(this.getSafeToRetryStorageKey(), JSON.stringify(payload));
    },

    removeSafeToRetryState() {
      localStorage.removeItem(this.getSafeToRetryStorageKey());
    },

    getRemainingSafeToRetryCountdown(startedAt) {
      const elapsedSeconds = Math.floor((Date.now() - Number(startedAt || Date.now())) / 1000);
      return Math.max(60 - elapsedSeconds, 0);
    },

    applySafeToRetryState(retryState) {
      this.safeToRetry.submitType = retryState.submitType;
      this.safeToRetry.retryCount = retryState.retryCount || 1;
      this.safeToRetry.countdown = this.safeToRetry.retryCount >= this.safeToRetry.maxRetry
        ? 0
        : this.getRemainingSafeToRetryCountdown(retryState.startedAt);

      if (this.safeToRetry.countdown > 0) {
        this.startSafeToRetryTimer();
      } else {
        this.clearSafeToRetryTimer();
      }
    },

    showStoredSafeToRetryModal(submitType) {
      const retryState = this.getStoredSafeToRetryState();

      if (!retryState) return false;

      const countdown = this.getRemainingSafeToRetryCountdown(retryState.startedAt);
      const isRetryLimitReached = retryState.retryCount >= this.safeToRetry.maxRetry;

      if (!isRetryLimitReached && countdown <= 0) {
        this.removeSafeToRetryState();
        return false;
      }

      this.applySafeToRetryState({
        ...retryState,
        submitType,
      });
      this.hideCetakSbgModals();
      this.$bvModal.show("modal-safe-to-retry");
      return true;
    },

    showSafeToRetryModal(submitType, retryCount) {
      const storedState = this.getStoredSafeToRetryState();
      const startedAt = storedState && storedState.retryCount === retryCount
        ? storedState.startedAt
        : Date.now();

      this.safeToRetry.submitType = submitType;
      this.safeToRetry.retryCount = retryCount || 1;
      this.safeToRetry.countdown = this.safeToRetry.retryCount >= this.safeToRetry.maxRetry
        ? 0
        : this.getRemainingSafeToRetryCountdown(startedAt);

      if (this.safeToRetry.countdown > 0) {
        this.saveSafeToRetryState(startedAt);
        this.startSafeToRetryTimer();
      } else {
        this.clearSafeToRetryTimer();
        this.saveSafeToRetryState(startedAt);
      }

      this.hideCetakSbgModals();
      this.$bvModal.show("modal-safe-to-retry");
    },

    hideCetakSbgModals() {
      this.$bvModal.hide("modal-confirm-cetak");
      this.$bvModal.hide("modal-confirm-cetak-baru");
    },

    startSafeToRetryTimer() {
      this.clearSafeToRetryTimer();
      this.safeToRetryTimer = setInterval(() => {
        if (this.safeToRetry.countdown <= 1) {
          this.safeToRetry.countdown = 0;
          this.clearSafeToRetryTimer();
          return;
        }

        this.safeToRetry.countdown--;
      }, 1000);
    },

    clearSafeToRetryTimer() {
      if (this.safeToRetryTimer) {
        clearInterval(this.safeToRetryTimer);
        this.safeToRetryTimer = null;
      }
    },

    async onRetryDisbursement() {
      if (
        this.safeToRetry.countdown > 0 ||
        this.safeToRetry.retryCount >= this.safeToRetry.maxRetry
      ) return;

      this.isSubmitting = true;
      this.removeSafeToRetryState();

      try {
        const response = await this.getCetakSbgResponse();
        await this.showPrintModalAfterRetrySuccess(response);
      } catch (error) {
        const message = this.$helper.parseError(this, error, '', false);
        const safeToRetryError = this.getSafeToRetryError(message);

        if (!safeToRetryError.isSafeToRetry) {
          this.clearSafeToRetryTimer();
          this.$bvModal.hide("modal-safe-to-retry");
          this.removeSafeToRetryState();
          this.showModalErrorCetak(message);
          return;
        }

        this.safeToRetry.retryCount = safeToRetryError.retryCount;

        if (this.safeToRetry.retryCount >= this.safeToRetry.maxRetry) {
          this.safeToRetry.countdown = 0;
          this.clearSafeToRetryTimer();
          this.saveSafeToRetryState();
          return;
        }

        this.safeToRetry.countdown = 60;
        this.saveSafeToRetryState();
        this.startSafeToRetryTimer();
      } finally {
        this.isSubmitting = false;
      }
    },

    async showPrintModalAfterRetrySuccess(response) {
      this.clearSafeToRetryTimer();
      this.removeSafeToRetryState();
      this.showDisbursementPendingAlert = false;
      this.$bvModal.hide("modal-safe-to-retry");

      if (this.safeToRetry.submitType === 'baru') {
        await this.showCetakSbgBaru(response);
        return;
      }

      this.showCetakSbgLama(response);
    },

    onSwitchToCashSafeRetry() {
      const payload = { gadaiId: this.id };
      this.isSubmitting = true;
      const switchRequest = () => this.$axios.post('gadai-disburse/switch-to-cash', {}, { params: payload });
      const shouldCancelDisbursement = this.dataDetailTransaksi.wajibTunai === true;

      const request = shouldCancelDisbursement
        ? this.$axios.post(`gadai-disburse/cancel-disbursement/${this.id}`).then(switchRequest)
        : switchRequest();

      return request
        .then((response) => {
          this.clearSafeToRetryTimer();
          this.removeSafeToRetryState();
          this.$bvModal.hide("modal-safe-to-retry");
          this.hideCetakSbgModals();
          this.$helper.toastSucc(this, response.data.name);
          this.init();
        })
        .catch((error) => {
          this.$helper.parseError(this, error);
        })
        .finally(() => {
          this.isSubmitting = false;
        });
    },

    async convertImageToBase64(source) {
      const blob = await fetch(source)
                          .then((result) => {
                            if (result.ok) {
                              return result.blob()
                            } else {
                              this.$bvModal.show("modal-perhatian")
                            }
                          })
                          .catch(() => {this.$bvModal.show("modal-perhatian")})

      const dataUrl = await new Promise((resolve) => {
        let reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.readAsDataURL(blob);
      });

      return dataUrl;
    },

    onVoid() {
      if (this.keterangan == "") {
        this.$helper.toastErr(this, "Mohon isi kotak keterangan!");
      } else {
        let payload = new FormData();
        this.isSubmitting = true;

        payload.append("gadaiId", this.id);
        payload.append("keterangan", this.keterangan);

        this.$axios
          .post("gadai/void/request", payload)
          .then(() => {
            this.$helper.setFlash(`Gadai void berhasil dilakukan!`);
            let path = this.$route.path.split("/");
            path.pop();
            path = path.join("/");
            this.$router.push({ path });
          })
          .catch((error) => {
            console.log(error);
            console.log(error.response.data.reason);
            this.$helper.parseError(this, error);
          })
          .finally(() => {
            this.isSubmitting = false;
          });
      }
    },

    //----------------- Fungsi Pindah Halaman dan Fungsi Lain -----------------

    confirmCetakSbg() {
      if (this.dataDetailTransaksi.counterPrintSbg == 0) {
        this.alertMsg =
          "Pencetakan SBG akan mengkonfirmasi penggadaian ini sebagai <strong>SAH</strong> dan <strong>BERJALAN</strong>. Pastikan kembali data yang diinput sudah sesuai!";
      } else {
        this.alertMsg = "";
      }

      this.$bvModal.show("modal-confirm-cetak");
    },

    confirmCetakSbgByTipe(tipe) {
      this.tipeSbg = tipe

      const alertMap = {
        baru: 'Pencetakan SBG Baru akan mengkonfirmasi penggadaian ini sebagai <strong>SAH</strong> dan <strong>BERJALAN</strong>. Pastikan kembali data yang diinput sudah sesuai!',
        v3: 'Pencetakan SBG V3 akan mengkonfirmasi penggadaian ini sebagai <strong>SAH</strong> dan <strong>BERJALAN</strong>. Pastikan kembali data yang diinput sudah sesuai!',
        v4: 'Pencetakan SBG V4 akan mengkonfirmasi penggadaian ini sebagai <strong>SAH</strong> dan <strong>BERJALAN</strong>. Pastikan kembali data yang diinput sudah sesuai!',
      }

      this.alertMsg =
        this.dataDetailTransaksi.counterPrintSbg == 0
          ? alertMap[tipe]
          : ''

      this.$bvModal.show('modal-confirm-cetak-baru')
    },

    confirmVoidGadai() {
      this.$bvModal.show("modal-confirm-void");
    },

    gantiUrlPrint(response) {
      this.urlSBG = this.$baseFilePath + response.data[0].name;
      this.urlKwitansi = this.$baseFilePath + response.data[1].name;
      this.urlBarcode = this.$baseFilePath + response.data[2].name;
    },

    goToCashierTransaction() {
      if (this.skipPrintModalRedirect) {
        this.skipPrintModalRedirect = false;
        return;
      }

      let path = this.$route.path.split("/");
      path.pop();
      path = path.join("/");
      this.$router.push({ path });
    },
    goToDisbursementPending() {
      this.skipPrintModalRedirect = true;
      this.$bvModal.hide("modal-print");
      this.$bvModal.hide("modal-print-baru");
      const path = this.disbursementPendingNoFaktur
        ? `/kasir/disbursement-pending/${this.disbursementPendingNoFaktur}`
        : "/kasir/disbursement-pending";
      this.$router.push({ path });
    },
    onStatusDisbursed(data) {
      this.statusDisbursed = data
    },
    onSafeRetryReset() {
      this.clearSafeToRetryTimer();
      this.removeSafeToRetryState();
      this.$bvModal.hide("modal-safe-to-retry");
      this.hideCetakSbgModals();
    },
    capitalize(value) {
      if (!value || typeof value !== 'string') return ''
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  },

  created() {
    this.init();
  },

  beforeDestroy() {
    this.clearSafeToRetryTimer();
  },
};
</script>

<style scoped>
.footer-wrapper-detail-transaksi-gadai {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px;
}

.footer-wrapper-btn-detail-transaksi-gadai {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}
</style>
